import React from 'react'
import { Navbar, NavItem, Icon } from "react-materialize"
import { Link } from 'react-router-dom'
const Nav = () => {
  return (
  

    <header className="container">
    <Navbar
      alignLinks='right'
      fixed="true"
      className="container white"
      brand={<Link to='/' className='brand-logo'>WelfareX <Icon className='hide-on-small-only'><img src='images/welfarex_logo_transparent_background.png' alt="WelfareX" height={64} style={{paddingLeft:30, padding: 10}} /></Icon></Link>}
      id="mobile-nav"
      menuIcon={<Icon className='nav-text'>menu</Icon>}
    >
      <NavItem className='nav-text' href='/about'> About Us </NavItem>
      <NavItem  className='nav-text' href='/book'> Book Service </NavItem>
      <NavItem  className='nav-text' href='/partner'> Partner Request </NavItem>
    </Navbar>
    </header>
  )

}

export default Nav